export interface ConformInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

export function conformInputPropsToAria(inputProps?: ConformInputProps) {
  if (!inputProps) {
    return {}; // Destructuring happens upstream so we pass an empty object
  }

  return {
    ...inputProps,
    maxLength: inputProps?.max, // Conform uses `max` while react-aria uses `maxLength`
    minLength: inputProps?.min,
  };
}
